import { Stack, Typography } from "@mui/material"
import React from "react"
import { styles } from "./styles/NotesItem.styles"
import moment from "moment"
import { FaUserTag } from "react-icons/fa"
import { useTranslation } from "react-i18next"

export const uiTranslationKey = {
  5: "vocabulary",
  4: "grammar",
  3: "NoteTypeId3",
  2: "NoteTypeId2",
  1: "NoteTypeId1",
  0: "NoteTypeId0",
}

export default function NotesItem({ item, onClick }) {
  const { t } = useTranslation()
  return (
    <Stack
      sx={[styles.item, item.isSelected && styles.itemSelected]}
      onClick={onClick}
    >
      <Stack>
        <Typography variant={"span"} sx={styles.title}>
          {item.noteTypeId === 0
            ? item.title
            : t(uiTranslationKey[item.noteTypeId] || item.noteType)}
        </Typography>
        <Typography variant={"span"} sx={styles.date}>
          {item.noteId > 0
            ? moment(item.lastUpdate).format("DD/MMM/YYYY")
            : "--/---/----"}
        </Typography>
      </Stack>
      {(item.isSharedNote || item.sharedWithUsers > 0) && (
        <FaUserTag style={styles.icon} />
      )}
    </Stack>
  )
}
